var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1 3.53151V23.9112H0.599976V3.53151L6.4506 1.09375L12.2037 3.53151L18.3469 1.09375L24.1 3.53151Z",
    stroke: "#0066FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.4921,
    y: 4.50723,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.79086,
    y: 4.50723,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7618,
    y: 4.50723,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.06057,
    y: 4.50723,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0315,
    y: 4.50723,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33029,
    y: 4.50723,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4921,
    y: 8.40567,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.79086,
    y: 8.40567,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7618,
    y: 8.40567,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6.06057,
    y: 8.40567,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0315,
    y: 8.40567,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33029,
    y: 8.40567,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4921,
    y: 12.3041,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 8.79086,
    y: 12.3041,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7618,
    y: 12.3041,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 6.06057,
    y: 12.3041,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0315,
    y: 12.3041,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33029,
    y: 12.3041,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4921,
    y: 16.2104,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 8.79086,
    y: 16.2104,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7618,
    y: 16.2104,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 6.06057,
    y: 16.2104,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0315,
    y: 16.2104,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33029,
    y: 16.2104,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4921,
    y: 20.1088,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 8.79086,
    y: 20.1088,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7618,
    y: 20.1088,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 6.06057,
    y: 20.1088,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0315,
    y: 20.1088,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33029,
    y: 20.1088,
    width: 0.780083,
    height: 1.56017,
    fill: "black",
    stroke: "#0066FF",
    strokeWidth: 0.780083
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 4.88975,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 6.45225,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 8.00694,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 9.56944,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 11.1319,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 12.6866,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 14.2491,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 15.8116,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 17.3741,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 18.9288,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 20.4913,
    r: 0.585062,
    fill: "#0066FF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3012,
    cy: 22.0538,
    r: 0.585062,
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/schoolIcon.613fb7ce071038afe6e95a36a46104e8.svg";
export { ForwardRef as ReactComponent };